import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { EDIT } from "const"
import { MtStudyTeamMember } from "server/models"
import {
    PRM_STUDY,
    StoreType,
    addModal,
} from "client/store"
import { hasProjectAccess } from "client/utils"
import {
    Link,
    TableColumn,
} from "client/components"

import Edit from "../edit"
import View from "../view"

const Columns = () => {
    const projectSettings = useSelector((state: StoreType) => state.project.projectSettings)
    const accountSettings = useSelector((state: StoreType) => state.system.accountSettings)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const editStudyAccess = hasProjectAccess(PRM_STUDY, EDIT)

    const { teamMembersFields } = projectSettings.study.teamMembersFieldsAssigned ? projectSettings.study : accountSettings.study

    const teamMemberLink = (teamMember: MtStudyTeamMember, linkContent: any) => (
        <Link
            href="/#"
            onClick={() => dispatch(addModal({
                key: editStudyAccess ? "editTeamMember" : "viewTeamMember",
                content: editStudyAccess
                    ? <Edit teamMemberId={teamMember.id} />
                    : <View teamMemberId={teamMember.id} />,
            }))}
        >
            {linkContent}
        </Link>
    )

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
            formatter: (teamMember: MtStudyTeamMember) => teamMemberLink(teamMember, teamMember.id),
        },
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "300px",
            formatter: (teamMember: MtStudyTeamMember) => teamMemberLink(teamMember, teamMember.name),
        },
        {
            field: "company",
            header: lang.company,
            display: teamMembersFields.company,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "200px",
        },
        {
            field: "title",
            header: lang.title,
            display: teamMembersFields.title,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "200px",
        },
        {
            field: "department",
            header: lang.department,
            display: teamMembersFields.department,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "200px",
        },
        {
            field: "competence",
            header: lang.competence,
            display: teamMembersFields.competence,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "200px",
        },
        {
            field: "phone",
            header: lang.phone,
            display: teamMembersFields.phone,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "200px",
        },
        {
            field: "email",
            header: lang.email,
            display: teamMembersFields.email,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "200px",
        },
        {
            field: "comments",
            header: lang.comments,
            display: teamMembersFields.comments,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "200px",
        },
    ]

    if (editStudyAccess) {
        columns.push({
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        })
    }

    return columns
}
export default Columns
